<fpc-input-field-label [label]="_label" [required]="required" [popoverText]="_popoverText" [labelColor]="labelColor" [iconSize]="iconSize">
    <textarea [id]="id" type="text" class="form-control h4" [formControl]="control" [placeholder]="placeholder" [name]="control" [required]="required"
        [minlength]="minlength" [maxlength]="maxlength" rows="5"></textarea>
</fpc-input-field-label>